
import { payforOne } from '@/api/task/withdraw'
// import { approvalRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'
import { oneClickPayfor, getPayWalletList } from '@/api/order/cashOrder'
import { delObjEmptyKey } from '@/utils'
@Component({
  name: 'approval',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any
  @Prop({ required: true }) private google!: any
  private statusList: any[] = []
  private setForm: any = {
    status: 2,
    order_number: this.info.ordernumber
  }
  private rules: any = {
    payWallets: [{ required: true, message: '请输入活动名称', trigger: 'blur' }]
  }
  private loading: boolean = false
  private productList: any[] = []
  private accountList: any[] = []
  private googleCode: any = ''
  private requiredRemarksGeogle: any = ''

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.setForm = {
      status: 2,
      order_number: this.info.ordernumber
    }
    this.requiredRemarks = ''
    this.requiredRemarksGeogle = ''
    this.$emit('close')
  }

  private isShow: boolean = false
  private requiredRemarks: string = ''
  private async payforOne() {
    if (!this.googleCode) {
      this.requiredRemarksGeogle = 'Google Code is required'
    }
    if (this.payWallets.length === 0) {
      this.isShow = true
      this.requiredRemarks = 'Wallet ID is required'
    } else {
      this.loading = true
      this.flag = true
      let arr: any = []
      this.payWallets.forEach(item => {
        arr.push(item.id)
      })
      let filters: any = {
        ...this.setForm
      }
      delObjEmptyKey(filters)
      const data: any = {
        filters: filters,
        pay_wallets: arr,
        google_code: this.googleCode
      }
      try {
        await oneClickPayfor(data).then(() => {
          this.$message({
            message: 'Operation successfully!',
            type: 'success'
          })
          this.loading = false
          this.flagStr()
          this.back()
        })
      } catch (e) {
        this.loading = false
        this.flagStr()
      }
    }
  }

  // 获取产品列表
  // private async getProductList () {
  //   await getProductList({
  //     product_type: this.info.product_type,
  //     currency: this.info.currency
  //   }).then((res: any) => {
  //     this.productList = res
  //   })
  // }

  private async onloadPayWalletList() {
    try {
      let data = {
        ...this.setForm
      }
      await getPayWalletList(data).then((res: any) => {
        this.accountList = res
      })
    } catch (error) {}
  }
  private payWallets: any = []
  private checkPlatformAll: boolean = false
  private isIndeterminatePlatform: boolean = false
  private platformCheckAllChange(val: any) {
    this.payWallets = val ? this.accountList : []
    this.isIndeterminatePlatform = false
  }
  private handleCheckedPlatformChange(value: any) {
    let checkedCount = value.length
    this.checkPlatformAll = checkedCount === this.accountList.length
    this.isIndeterminatePlatform =
      checkedCount > 0 && checkedCount < this.accountList.length
  }

  // private selProduct () {
  //   this.setForm.product_account = null
  //   this.getAccountList()
  // }

  // // 获取产品账户列表
  // private async getAccountList () {
  //   const params = {
  //     product: this.setForm.product,
  //     status: 1,
  //     page: 1,
  //     page_size: 1000
  //   }
  //   await getProductAccountList(params).then((res: any) => {
  //     this.accountList = res.results
  //   })
  // }

  created() {
    this.onloadPayWalletList()
  }
}
